import React from "react";
import { User } from "./types";

interface Props {
    users: User[];
    onEdit: (user: User) => void;
    onDelete: (userId: number) => void;
    onLoginAs: (user: User) => void;
}

const UserList: React.FC<Props> = ({ users, onEdit, onDelete, onLoginAs }) => (
    <div className="nice-table-wrap">
        <table
            className="event-table event-table-modern nice-table"
        >
            <thead>
                <tr>
                    <th>Email</th>
                    <th>Fornavn</th>
                    <th>Efternavn</th>
                    <th>Telefon</th>
                    <th>Roller</th>
                    <th>Handling</th>
                </tr>
            </thead>
            <tbody>
                {users.map(u => (
                    <tr key={u.userId}>
                        <td>{u.email}</td>
                        <td>{u.firstName}</td>
                        <td>{u.lastName}</td>
                        <td>{u.phone}</td>
                        <td>{u.userRoles?.map(r => r.roleName).join(", ")}</td>
                        <td>
                            <div className="table-buttons">
                            <button className="btn btn--edit" onClick={() => onEdit(u)}>Rediger</button>
                            <button className="btn btn--delete" onClick={() => onDelete(u.userId)}>Slet</button>
                                <button className="btn btn--function" onClick={() => onLoginAs(u)}>Login som</button>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default UserList;